export default __webpack_public_path__ + "static/media/aboutJs.ee963ded.jpg";